<ng-container *ngIf="filters$ | async as filters">
  <ng-container *ngIf="filters">
    <div class="flex items-center font-medium pl-3 pr-2 mb-1">
      <span>{{ 'elioTable.filter' | transloco }}</span>
      <button class="flex items-center ml-auto" (click)="reset()" data-qa="filter-list-clear">
        <elio-svg-icon [pTooltip]="'elioTable.clearTooltip' | transloco" key="cross"></elio-svg-icon>
      </button>
    </div>
    <elio-filter-item [filter]="filters" />
  </ng-container>
</ng-container>
